import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Divider } from 'primereact/divider';
import { useTranslation } from 'react-i18next';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';
import styles from './ResolveFailureDialog.styles.scss';
import cn from 'classnames';

const ResolveFailureDialog = ({ isOpen, setIsOpen, referenceNumber }) => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  return (
    <Dialog
      className={cn('rounded-4 overflow-hidden', styles.resolveFailureDialog)}
      visible={isOpen}
      onHide={() => {
        setIsOpen(false);
        navigate(
          `/${i18n.language}/additional-functionalities/failure-notification`,
        );
      }}
      footer={
        <>
          <Divider className="mb-4" />
          <Button
            type="button"
            className="px-5 w-100"
            size="medium"
            label={t('common.home')}
            onClick={() =>
              navigate(
                `/${i18n.language}/additional-functionalities/failure-notification`,
              )
            }
          />
        </>
      }
    >
      <div className={styles.submissionMessage}>
        <span>
          <div>
            <i className="pi icn-check" />
          </div>
        </span>
        <h3>
          {t('failure_notification.technical_failure_resolved', {
            number: referenceNumber,
          })}
        </h3>
      </div>
    </Dialog>
  );
};

export default ResolveFailureDialog;
